module.exports = __webpack_public_path__ + "img/hair_back_male_spiked_mask.72daf77b.png";